export enum PermissionTypes {
  CAMERA,
  ACCESS_COARSE_LOCATION,
  BLUETOOTH_CONNECT,
  BLUETOOTH_SCAN,
}
